import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { looseString } from '../common/util/SearchParams'
import PeyoteDebugger from '../components/peyote-debugger/PeyoteDebugger'

export const Route = createFileRoute('/_a/peyote/debugger')({
  component: PeyoteDebugger,
  validateSearch: z.object({
    companyIntegrationId: looseString.optional(),
  }),
})
